import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  // CORREÇÃO 1: Sintaxe correta de atribuição (=) e não comparação (===)
  const isDark = theme.palette.type === 'dark'

  // CORREÇÃO 2: O escopo do hook precisa retornar o objeto de classes CSS de forma explícita
  return {
    container: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4)
    },
    fixedHeightPaper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
      height: 240
    },
    tab: {
      borderRadius: 4,
      width: '100%',
      '& .MuiTab-wrapper': {
        color: '#128c7e'
      },
      '& .MuiTabs-flexContainer': {
        justifyContent: 'center'
      }
    },
    paper: {
      padding: '0 25px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: 12,
      width: '100%'
    },
    cardAvatar: {
      fontSize: '55px',
      backgroundColor: '#ffffff',
      width: theme.spacing(7),
      height: theme.spacing(7)
    },
    cardTitle: {
      fontSize: '18px'
    },
    cardSubtitle: {
      fontSize: '14px'
    },
    alignRight: {
      textAlign: 'right'
    },
    fullWidth: {
      width: '100%'
    },
    colorAdorment: {
      width: 20,
      height: 20
    },

    groupTitle: {
      margin: 0,
      color: theme.palette.blue_300.main,
      fontWeight: '600'
    },
    groupContent: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      width: '100%'
    },
    groupIcon: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.blue_300.main
    },
    iconLock: {
      color: theme.palette.blue_300.main,
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },

    boxContentGroup: {
      display: 'flex',
      gap: '8px',
      flexDirection: 'column',
      // OTIMIZAÇÃO: Injetando a variável isDark para simplificar as condicionais ternárias inline
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      padding: '6px 8px',
      borderRadius: 16,
      overflow: 'hidden',
      marginBottom: '8px',
      backgroundColor: isDark
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main
    },
    helpText: {
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      fontSize: '0.875rem',
      marginTop: '4px'
    },
    helpButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      cursor: 'pointer',
      justifyContent: 'space-between'
    },
    boxPopover: {
      padding: 10,
      width: '300px',
      minWidth: '300px',
      fontSize: '1rem',
      backgroundColor: isDark
        ? theme.palette.dark_600.main
        : theme.palette.gray_100.main,
      borderRadius: 8,
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
    },
    inputButtonHelp: {
      color: theme.palette.blue_300.main,
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    uploadInput: {
      display: 'none'
    },
    boxGrid: {
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      marginTop: '8px',
      borderRadius: 16
    },
    boxGridService: {
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      marginTop: '8px',
      borderRadius: 16,
      padding: '10px !important'
    },
    storageSectionHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: '16px',
      flexWrap: 'wrap',
      marginBottom: '14px'
    },
    storageSectionIntro: {
      margin: '6px 0 0',
      maxWidth: 760,
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      fontSize: '0.95rem',
      lineHeight: 1.55
    },
    storageStatusCard: {
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      borderRadius: 16,
      padding: '16px',
      marginBottom: '14px',
      background: isDark
        ? theme.palette.dark_700?.main || theme.palette.white_100.main
        : 'linear-gradient(180deg, rgba(18,140,126,0.06), rgba(18,140,126,0.02))'
    },
    storageStatusBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: '4px 10px',
      borderRadius: 999,
      fontSize: '0.78rem',
      fontWeight: 700,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      backgroundColor: isDark
        ? 'rgba(255,255,255,0.08)'
        : 'rgba(18,140,126,0.12)'
    },
    storageStatusText: {
      margin: '10px 0 0',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      lineHeight: 1.5
    },
    storageTestTitle: {
      margin: '18px 0 10px',
      fontSize: '0.78rem',
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
    },
    storageChecklist: {
      margin: 0,
      paddingLeft: '20px',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      lineHeight: 1.6
    },
    storageChecklistItem: {
      marginBottom: '8px'
    },
    storageTestResults: {
      marginTop: '16px',
      display: 'grid',
      gap: '10px'
    },
    storageCheckItem: {
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      borderRadius: 12,
      padding: '12px'
    },
    storageCheckHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '12px',
      marginBottom: '6px'
    },
    storageCheckStatusSuccess: {
      color: theme.palette.success?.main || '#1f8f55',
      fontWeight: 700,
      fontSize: '0.8rem',
      textTransform: 'uppercase'
    },
    storageCheckStatusError: {
      color: theme.palette.error?.main || '#c62828',
      fontWeight: 700,
      fontSize: '0.8rem',
      textTransform: 'uppercase'
    },
    storageCheckMessage: {
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      lineHeight: 1.5
    },
    storageDebugDetails: {
      marginTop: '16px',
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      borderRadius: 12,
      overflow: 'hidden'
    },
    storageDebugSummary: {
      cursor: 'pointer',
      padding: '12px 14px',
      fontWeight: 700,
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      outline: 'none'
    },
    storageDebugPre: {
      margin: 0,
      padding: '0 14px 14px',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      fontSize: '0.78rem',
      lineHeight: 1.5,
      fontFamily: 'monospace',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      backgroundColor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)'
    },
    storageGuideCard: {
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      borderRadius: 16,
      padding: '16px',
      marginBottom: '14px'
    },
    storageGuideTitle: {
      margin: 0,
      fontSize: '0.78rem',
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
    },
    storageGuideList: {
      margin: '12px 0 0',
      paddingLeft: '20px',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      lineHeight: 1.6
    },
    storageGuideLink: {
      color: theme.palette.blue_300.main,
      textDecoration: 'none',
      fontWeight: 600,
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    storageFormCard: {
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      borderRadius: 16,
      padding: '16px',
      background: isDark
        ? theme.palette.dark_600.main
        : theme.palette.white_100.main
    },
    storageFormHeader: {
      marginBottom: '12px'
    },
    storageFormTitle: {
      margin: 0,
      fontSize: '1rem',
      fontWeight: 700,
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
    },
    storageFormDescription: {
      margin: '4px 0 0',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      fontSize: '0.9rem',
      lineHeight: 1.5
    },
    boxContainer: {
      display: 'flex',
      gap: '2px'
    },
    boxContentSwitch: {
      display: 'flex',
      gap: '8px',
      flexWrap: 'wrap',
      marginTop: '8px'
    },
    boxContentInputMessage: {
      display: 'flex',
      gap: '8px',
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
        maxWidth: '100%'
      }
    },
    boxContent: {
      display: 'flex',
      gap: '8px',
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
        maxWidth: '100%'
      }
    },
    groupInput: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    boxContentInput: {
      display: 'flex',
      gap: '8px',
      marginBottom: '8px',
      backgroundColor: isDark
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      padding: '10px !important',
      borderRadius: 16,
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
        maxWidth: '100%'
      }
    },
    alignCenter: {
      marginTop: '32px'
    },
    formControlLabel: {
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
    },
    radio: {
      color: theme.palette.blue_300.main,
      '&.Mui-checked': {
        color: theme.palette.blue_300.main
      }
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    boxInputWrapper: {
      display: 'flex',
      gap: '8px'
    },
    boxInputTransition: {
      transition: 'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out',
      display: 'flex',
      alignItems: 'flex-end',
      flexWrap: 'wrap',
      gap: '8px'
    },
    selectTempo: {
      maxWidth: '100px',
      width: '100px',
      flexShrink: 0
    },
    selectTempoReopen: {
      maxWidth: '120px',
      width: '120px',
      flexShrink: 0
    },
    selectAcao: {
      flex: 1,
      minWidth: '140px'
    },
    inputNumber: {
      border: '1px solid red',
      '& input[type="number"]': {
        maxWidth: '150px'
      }
    },

    accordion: {
      borderRadius: '16px !important',
      overflow: 'hidden',
      '& .MuiAccordionSummary-root': {
        minHeight: '36px !important'
      },
      '& .MuiAccordionDetails-root': {
        padding: '0 16px 8px !important'
      },
      '& .MuiAccordionSummary-content.Mui-expanded': {
        margin: '12px 0 !important'
      },
      '& .MuiSvgIcon-root': {
        color: theme.palette.blue_300.main
      }
    },
    accordionDetailsHighlighted: {
      backgroundColor: isDark
        ? theme.palette.dark_900.main
        : theme.palette.gray_20.main,
      borderTop: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      padding: '16px !important',
      width: '100%'
    },

    iconButton: {
      backgroundColor: 'transparent',
      color: theme.palette.blue_300.main,
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    iconButtonLink: {
      backgroundColor: 'transparent',
      color: theme.palette.blue_300.main,
      marginTop: '20px',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },

    IconLock: {
      backgroundColor: 'transparent',
      color: theme.palette.blue_300.main,
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },

    description: {
      fontSize: '0.875rem',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
    },

    transferContainer: {
      display: 'flex',
      alignItems: 'center',
      width: 'fit-content',
      maxWidth: '650px',
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      borderRadius: '15px',
      padding: '10px',
      margin: '10px 0'
    },
    transferTitle: {
      color: theme.palette.blue_300.main,
      margin: '0',
      fontSize: '1rem'
    },
    transferDescription: {
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      fontSize: '0.9rem',
      marginLeft: '20px',
      lineHeight: '1.4'
    },

    boxPixContainer: {
      display: 'flex',
      alignItems: 'center',
      padding: '14px',
      borderRadius: '12px',
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      backgroundColor: isDark
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
      position: 'relative'
    },
    boxForm: {
      padding: '16px',
      borderRadius: '12px',
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      backgroundColor: isDark
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main
    },
    boxHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '10px',
      borderBottom: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      paddingBottom: '10px',
      '& h6': {
        fontWeight: 600,
        color: isDark
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
        textTransform: 'uppercase',
        fontSize: '0.75rem'
      },
      '& button': {
        color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
      }
    },
    iconPixContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '40px',
      height: '40px',
      borderRadius: '10px',
      backgroundColor: isDark
        ? theme.palette.dark_600.main
        : theme.palette.blue_50.main,
      color: '#2563EB',
      marginRight: '16px',
      flexShrink: 0
    },
    pixAccountName: {
      fontWeight: 600,
      fontSize: '.875rem',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    pixType: {
      display: 'inline-block',
      padding: '1px 6px',
      borderRadius: '6px',
      marginTop: '4px',
      backgroundColor: isDark
        ? theme.palette.dark_600.main
        : theme.palette.gray_100.main,
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      fontSize: '0.75rem',
      fontWeight: 500,
      textTransform: 'uppercase'
    },
    editButton: {
      color: theme.palette.blue_300.main,
      background: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    deleteButton: {
      color: theme.palette.red_100.main,
      background: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    boxActions: {
      display: 'flex',
      alignItems: 'center',
      gap: 4,
      marginLeft: '8px',
      flexShrink: 0
    },
    iconButtonAdd: {
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main,
      padding: 0,
      height: '32px',
      width: '32px',
      borderRadius: '8px',
      '&:hover': {
        backgroundColor: theme.palette.green_200.main
      }
    },
    containerPix: {
      display: 'flex',
      alignItems: 'end',
      gap: '8px',
      marginTop: '6px',
      marginBottom: '6px',
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      padding: '6px 8px',
      borderRadius: 16,
      overflow: 'hidden',
      backgroundColor: isDark
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main
    },
    contentPix: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'end',
      gap: '8px',
      borderRadius: '8px',
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`
    },
    iconButtonDelete: {
      backgroundColor: 'transparent',
      color: theme.palette.red_100?.main || '#EF4444',
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    inputWrapper: {
      display: 'flex',
      alignItems: 'end',
      gap: '8px',
      width: '100%'
    },
    textEmpty: {
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
    },

    mainPaper: {
      width: '100%',
      flex: 1,
      padding: theme.spacing(2)
    },
    formLabel: {
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
    }
  }
})
